import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://a7a2d5af43a57371717e56b8b9c7c715@o4507492423434240.ingest.de.sentry.io/4508361098395728",
  integrations: [
    Sentry.browserTracingIntegration(), Sentry.replayIntegration(),
  ],
  environment: process.env.NODE_ENV,
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/dev.eot.lumian\.energy/, /^https:\/\/app.eot.lumian\.energy/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeSend: (event) => {
    if (window.location.hostname === "localhost") {
      return null;
    }
    return event;
  },
});
